module.exports = __webpack_public_path__ + "img/13.c5cfed84.png";